import styled from "styled-components";

export const TopOfPageFocusTarget = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  transform: translateY(-1000%);

  &:focus-visible {
    position: relative;
    transform: translateY(0%);
  }
`;
